import React from 'react';
import { Line } from "react-chartjs";

const chartOptions = {
    scaleShowHorizontalLines: true,
    responsive: true,
    barValueSpacing: 10
};


const WalletChart = ({ chartData }) => {
    return (
        <div>
            <Line data={chartData} options={chartOptions} />
        </div>
    );
};

export default WalletChart;



// WEBPACK FOOTER //
// ./src/views/Settlement/walletChart.js